import * as fieldValueAPI from '../../api/fieldValue';

export const saveManyFieldValues = async (fieldValues, token = '') => Promise.all(fieldValues.map(
  async (field) => fieldValueAPI.saveFieldValue(field, token),
));
